import React from "react";
import { connect } from "react-redux";
import { fetchOffers } from "../../action/apiCallActions";
import { browserHistory, withRouter } from "react-router";

const bangalore = { lat: 12.9716, lng: 77.5946 };
const chennai = { lat: 13.082, lng: 80.2707 };
const hyderabad = { lat: 17.385, lng: 78.4867 };
const pune = { lat: 18.5204, lng: 73.8567 };
const dubai = { lat: 25.2048, lng: 55.2708 };
const delhi = { lat: 28.7041, lng: 77.1025 };
const ahmedabad = { lat: 23.0225, lng: 72.5714 };
const bhopal = { lat: 23.2599, lng: 77.4126 };
const indore = { lat: 22.7196, lng: 75.8577 };
const chandigarh = { lat: 30.7333, lng: 76.7794 };
const kolkata = { lat: 22.5726, lng: 88.3639 };
const mumbai = { lat: 19.076, lng: 72.8777 };

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show: false, city: "Bengaluru" };
    this.toggle = this.toggle.bind(this);
    this.fetchOffers = this.fetchOffers.bind(this);
  }

  toggle(e) {
    e.preventDefault();
    this.setState({ show: !this.state.show });
  }

  fetchOffers(city, name) {
    browserHistory.push("/offers-and-coupons");
    this.setState({ show: !this.state.show, city: name });
    this.props.dispatch(fetchOffers(city));
  }

  componentDidMount() {
    const { location } = this.props;
    if (location && location.pathname === "/offers-and-coupons/uae") {
      this.setState({ city: "Dubai" });
      this.props.dispatch(fetchOffers(dubai));
    }
  }

  render() {
    return (
      <div className="city_dropDown">
        <div className="city-dropdown-div" onClick={this.toggle.bind(this)}>
          <span onClick={this.toggle.bind(this)}>{this.state.city}</span>
          <img
            src="https://s3.ap-south-1.amazonaws.com/playo-website/Offers/select.svg"
            alt=""
            onClick={this.toggle.bind(this)}
          />
        </div>

        {this.state.show ? (
          <div className="relative_position">
            <ul className="city_dropdown-ul">
              <li onClick={this.fetchOffers.bind(this, bangalore, "Bengaluru")}>Bengaluru</li>
              <li onClick={this.fetchOffers.bind(this, hyderabad, "Hyderabad")}>Hyderabad</li>
              <li onClick={this.fetchOffers.bind(this, chennai, "Chennai")}>Chennai</li>
              <li onClick={this.fetchOffers.bind(this, delhi, "Delhi")}>Delhi</li>
              <li onClick={this.fetchOffers.bind(this, pune, "Pune")}>Pune</li>
              <li onClick={this.fetchOffers.bind(this, dubai, "Dubai")}>Dubai</li>
            </ul>
          </div>
        ) : (
          <span />
        )}
      </div>
    );
  }
}

export default connect()(withRouter(DropDown));



// WEBPACK FOOTER //
// ./src/components/Navbar/cityDropDown.js